<div class="editbet-onboarding-dialog_content">
    <div class="editbet-onboarding-dialog_header">
        <div class="editbet-onboarding-dialog_header-title">
            <b>{{ siteCore.betslip.editBet.infoHeaderTitle }}</b>
            <p>{{ siteCore.betslip.editBet.infoHeaderText }}</p>
        </div>
        <div class="editbet-onboarding-dialog_header-close theme-ex" (click)="close()"></div>
    </div>
    <div class="editbet-onboarding-dialog_top">
        <div class="betslip-edit-bet_add-button-container">
            <button ds-button msThemedButton kind="secondary" variant="outline" size="medium" [themeKind]="buttonThemeKind">
                <vn-icon slot="start" name="theme-plus" size="12" />
                {{ siteCore.betslip.editBet.addSelection }}
            </button>
        </div>
        <div class="editbet-onboarding-dialog_top_description">
            <b>{{ siteCore.betslip.editBet.infoAddTitle }}</b>
            <p>{{ siteCore.betslip.editBet.infoAddDesc }}</p>
        </div>
    </div>
    <div class="editbet-onboarding-dialog_middle-part">
        <div class="editbet-onboarding-dialog_middle-part_wrapper">
            <div class="editbet-onboarding-dialog_middle-part_left">
                <i class="betslip-icon sports-swap"></i>
                <div class="editbet-onboarding-dialog_left_description">
                    <b>{{ siteCore.betslip.editBet.infoSwapTitle }}</b>
                    <p>{{ siteCore.betslip.editBet.infoSwapDesc }}</p>
                </div>
            </div>
            <div class="editbet-onboarding-dialog_middle-part_right">
                <i class="betslip-icon sports-edit-bet-delete"></i>
                <div class="editbet-onboarding-dialog_right_description">
                    <b>{{ siteCore.betslip.editBet.infoRemoveTitle }}</b>
                    <p>{{ siteCore.betslip.editBet.infoRemoveDesc }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="editbet-onboarding-dialog_bottom">
        <div class="editbet-onboarding-dialog_bottom_stake">
            <div class="editbet-onboarding-dialog_bottom_description">
                <b>{{ siteCore.betslip.editBet.infoStakeTitle }}</b>
                <p>{{ siteCore.betslip.editBet.infoStakeDesc }}</p>
            </div>
            <div class="betslip-edit-bet_add-button-container">
                <button ds-button msThemedButton kind="secondary" variant="outline" size="medium" [themeKind]="buttonThemeKind">
                    <vn-icon slot="start" name="theme-plus" size="12" />
                    {{ siteCore.betslip.editBet.addStake }}
                </button>
            </div>
        </div>
        <div class="editbet-onboarding-dialog_confirm-button-container">
            <button ds-button kind="primary" variant="filled" size="large" id="confirm-button" (click)="okay()">
                {{ siteCore.betslip.editBet.infoConfirm }}
            </button>
        </div>
        <div class="editbet-onboarding-dialog_help" (click)="help()">
            {{ siteCore.betslip.editBet.infoHelp }}<i class="theme-right" *msShowInEpcot="true"></i>
        </div>
    </div>
</div>
